import { strCode } from "../../consts";

const consentFlagOptions = [
  {
    id: "XP_PIR",
    value: "XP_PIR",
    description: strCode.XP_PIR_DESCRIPTION
  },
  {
    id: "XP_PIA",
    value: "XP_PIA",
    description: strCode.XP_PIA_DESCRIPTION
  },
  {
    id: "XP_MSG",
    value: "XP_MSG",
    description: strCode.XP_MSG_DESCRIPTION
  },
  {
    id: "XP_DIA",
    value: "XP_DIA",
    description: strCode.XP_DIA_DESCRIPTION
  },
  {
    id: "XP_SELF",
    value: "XP_SELF",
    description: strCode.XP_SELF_DESCRIPTION
  },
  {
    id: "EVENTS_PIR",
    value: "EVENTS_PIR",
    description: strCode.EVENTS_PIR_DESCRIPTION
  },
  {
    id: "EVENTS_PIA",
    value: "EVENTS_PIA",
    description: strCode.EVENTS_PIA_DESCRIPTION
  },
  {
    id: "EVENTS_MSG",
    value: "EVENTS_MSG",
    description: strCode.EVENTS_MSG_DESCRIPTION
  },
  {
    id: "EVENTS_DIA",
    value: "EVENTS_DIA",
    description: strCode.EVENTS_DIA_DESCRIPTION
  },
  {
    id: "EVENTS_SELF",
    value: "EVENTS_SELF",
    description: strCode.EVENTS_SELF_DESCRIPTION
  },
  {
    id: "ERRORS_PIR",
    value: "ERRORS_PIR",
    description: strCode.ERRORS_PIR_DESCRIPTION
  },
  {
    id: "ERRORS_PIA",
    value: "ERRORS_PIA",
    description: strCode.ERRORS_PIA_DESCRIPTION
  },
  {
    id: "ERRORS_MSG",
    value: "ERRORS_MSG",
    description: strCode.ERRORS_MSG_DESCRIPTION
  },
  {
    id: "ERRORS_DIA",
    value: "ERRORS_DIA",
    description: strCode.ERRORS_DIA_DESCRIPTION
  },
  {
    id: "ERRORS_SELF",
    value: "ERRORS_SELF",
    description: strCode.ERRORS_SELF_DESCRIPTION
  },
  {
    id: "SETTINGS_PIR",
    value: "SETTINGS_PIR",
    description: strCode.SETTINGS_PIR_DESCRIPTION
  },
  {
    id: "SETTINGS_PIA",
    value: "SETTINGS_PIA",
    description: strCode.SETTINGS_PIA_DESCRIPTION
  },
  {
    id: "SETTINGS_MSG",
    value: "SETTINGS_MSG",
    description: strCode.SETTINGS_MSG_DESCRIPTION
  },
  {
    id: "SETTINGS_DIA",
    value: "SETTINGS_DIA",
    description: strCode.SETTINGS_DIA_DESCRIPTION
  },
  {
    id: "SETTINGS_SELF",
    value: "SETTINGS_SELF",
    description: strCode.SETTINGS_SELF_DESCRIPTION
  }
];

export default consentFlagOptions;
